import type { FormikProps } from 'formik'
import { useFormikContext } from 'formik'
import { BoxV2, CheckBoxFieldv2, ExternalLink } from '@labrav/react-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faListCheck } from '@fortawesome/pro-regular-svg-icons'
import { useStyles } from './ResellerAgreementAcceptance.styles'

export const ResellerAgreementAcceptance = ({
  resellerLicenseAgreementUrl,
}: {
  resellerLicenseAgreementUrl: string
}) => {
  const { classes } = useStyles()
  const formikProps = useFormikContext() as FormikProps<Record<string, unknown>>
  const { values, errors } = formikProps

  const handleAcceptanceChange = async (value: boolean) => {
    formikProps.setFieldValue('isResellerLicenseAgreementAccepted', value)
  }

  return (
    <>
      <div data-testid="cppo-reseller-agreement-acceptance-check">
        <BoxV2
          heading={'Reseller agreement'}
          headingIcon={
            <FontAwesomeIcon
              icon={faListCheck}
              style={{ width: '14px', height: '14px' }}
            />
          }
        >
          <div
            className={classes.checkboxContainer}
            data-testid="reseller-agreement-acceptance-container"
          >
            <CheckBoxFieldv2
              keyName="isResellerAgreementAccepted"
              title={
                <div className={classes.acceptanceTermsContainer}>
                  <p className={classes.acceptanceText}>
                    I accept this reseller agreement for AWS Marketplace (RCMP).
                  </p>
                  <div
                    className={classes.acceptanceTermDetailsContainer}
                    data-testid="reseller-agreement-acceptance-term-detail"
                  >
                    <p className={classes.acceptanceTermDetails}>
                      This agreement is between you and the ISV. Buyers will not
                      see this.
                    </p>
                    <ExternalLink href={resellerLicenseAgreementUrl}>
                      View Agreement
                    </ExternalLink>
                  </div>
                  {errors?.isResellerLicenseAgreementAccepted && (
                    <div className={classes.errorText}>
                      {errors?.isResellerLicenseAgreementAccepted}
                    </div>
                  )}
                </div>
              }
              value={!!values?.isResellerLicenseAgreementAccepted}
              onChangeBox={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleAcceptanceChange(e.target.checked)
              }}
            />
          </div>
        </BoxV2>
      </div>
    </>
  )
}
